import { createCookie } from '@rover/utilities/cookie';

const leverCookies = {
  'lever-origin': 'applied',
  'lever-source': 'Site_Footer',
};

const createCookieFromObj = ([key, value]) => createCookie(key, value, 30);

const setLeverCookies = () => Object.entries(leverCookies).map(createCookieFromObj);

export default setLeverCookies;



// WEBPACK FOOTER //
// ../utilities/lever.js